import { useContainer } from '@hub-la/fe-container';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { useMutation } from 'react-query';
import { QueryKey } from '../../domain/dtos/query-keys.js';
import { SignoutRoleplay } from '../../usecases/signout-roleplay.js';

const useSignOutRoleplay = input => {
  const container = useContainer();
  return useMutation([QueryKey.postSignOutRoleplay], () => new SignoutRoleplay(container.get(HttpClient)).execute(), {
    retry: false,
    onSuccess: input === null || input === void 0 ? void 0 : input.onSuccess
  });
};

export { useSignOutRoleplay };
